module.exports = __webpack_public_path__ + "img/kids-green.2ac915ef.jpg";